'use client';

import AutoScroll from 'embla-carousel-auto-scroll';
import useEmblaCarousel from 'embla-carousel-react';
import Image from 'next/image';

const brands = [
  {
    name: 'Animeca',
    logo: '/clients/logo_1.png',
  },
  {
    name: 'dsm-firmenich',
    logo: '/clients/logo_2.png',
  },
  {
    name: 'Liberty',
    logo: '/clients/logo_3.png',
  },
  {
    name: 'Istobal',
    logo: '/clients/logo_4.png',
  },
  {
    name: "Tod's",
    logo: '/clients/logo_5.png',
  },
  {
    name: 'Hugo Boss',
    logo: '/clients/logo_6.png',
  },
  {
    name: 'Miami',
    logo: '/clients/logo_7.png',
  },
  {
    name: 'Le biennale',
    logo: '/clients/logo_8.png',
  },
  {
    name: 'Meta',
    logo: '/clients/logo_9.png',
  },
  {
    name: 'Roshn Group',
    logo: '/clients/logo_10.png',
  },
  {
    name: 'Sandbox',
    logo: '/clients/logo_11.png',
  }
];

const brands2 = [
  {
    name: 'EA7',
    logo: '/clients/logo_12.png',
  },
  {
    name: 'Biotronik',
    logo: '/clients/logo_13.png',
  },
  {
    name: 'Macdonalds',
    logo: '/clients/logo_14.png',
  },
  {
    name: '',
    logo: '/clients/logo_15.png',
  },
  {
    name: "Netflix",
    logo: '/clients/logo_16.png',
  },
  {
    name: 'Lacoste',
    logo: '/clients/logo_17.png',
  },
  {
    name: 'FHP',
    logo: '/clients/logo_18.png',
  },
  {
    name: 'XMANNA',
    logo: '/clients/logo_19.png',
  },
  {
    name: 'RAMZ',
    logo: '/clients/logo_20.png',
  },
  {
    name: 'Xiaomi',
    logo: '/clients/logo_21.png',
  },
  {
    name: 'Web Summit',
    logo: '/clients/logo_22.png',
  }
];

interface Props {
  direction: boolean;
}

export default function BrandCarousel(props: Props) {
  const { direction } = props;

  const dir = direction ? 'rtl' : 'ltr';

  const currentBrands = direction ? brands : brands2;

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      direction: dir,
    },
    [
      //@ts-ignore
      AutoScroll({
        playOnInit: true,
        stopOnInteraction: false,
        stopOnFocusIn: false,
        speed: 1,
      }),
    ]
  );

  return (
    <div className='embla !my-0 !mx-0 w-[98vw] max-w-[1920px] sm:my-0 sm:mx-0 md:mx-0 md:my-0'>
      <div className='embla__viewport' ref={emblaRef}>
        <div className='embla__container' dir={dir}>
          {currentBrands.map((brand, index) => (
            <div
              className='embla__slide flex items-center justify-center sm:mx-1 mx-16 lg:mx-8'
              key={index}
            >
              <img
                src={brand.logo}
                alt={brand.name}
                height={144}
                className=' color-[white]'
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
